/* Product image zoom viewer (sections/main-product, <dialog data-pz>).
   Phones:  swipe between photos · pinch to zoom · double-tap to zoom in/out
            at that spot · drag to look around while zoomed.
   Desktop: click zooms in where you point, moving the mouse looks around,
            click again zooms out · trackpad pinch (ctrl + wheel) zooms ·
            arrows / ← → keys change photo · Esc closes.
   All gestures are handled here (touch-action: none on the stage), so pinch
   never fights the page's own zoom or the swipe. */
(function () {
  'use strict';
  var MAX = 4, TAP_ZOOM = 2.5;

  function Viewer(dialog) {
    this.d = dialog;
    this.stage = dialog.querySelector('[data-pz-stage]');
    this.track = dialog.querySelector('[data-pz-track]');
    this.slides = Array.prototype.slice.call(dialog.querySelectorAll('[data-pz-slide]'));
    this.dots = Array.prototype.slice.call(dialog.querySelectorAll('.pz__dot'));
    this.cur = dialog.querySelector('[data-pz-cur]');
    this.hint = dialog.querySelector('[data-pz-hint]');
    this.i = 0; this.s = 1; this.x = 0; this.y = 0;
    this.pts = {}; this.dragX = 0;
    this.fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (this.fine && this.hint) this.hint.textContent = 'Click to zoom · move to look around';
    this.bind();
  }

  Viewer.prototype.img = function () { return this.slides[this.i] && this.slides[this.i].querySelector('img'); };

  Viewer.prototype.load = function (n) {
    var sl = this.slides[n]; if (!sl) return;
    var im = sl.querySelector('img');
    if (im.getAttribute('src')) return;
    /* small copy first so it shows at once, full size swaps in when ready */
    im.src = im.getAttribute('data-pz-lo');
    var hi = new Image();
    hi.onload = function () { im.src = hi.src; };
    hi.src = im.getAttribute('data-pz-src');
  };

  Viewer.prototype.open = function (n) {
    this.go(n, true);
    document.documentElement.classList.add('pz-open');
    if (this.d.showModal) this.d.showModal(); else this.d.setAttribute('open', '');
    var self = this;
    if (this.hint) { this.hint.classList.remove('is-gone'); clearTimeout(this.hintT); this.hintT = setTimeout(function () { self.hint.classList.add('is-gone'); }, 2600); }
  };

  Viewer.prototype.close = function () {
    this.reset(true);
    document.documentElement.classList.remove('pz-open');
    if (this.d.close) this.d.close(); else this.d.removeAttribute('open');
  };

  Viewer.prototype.go = function (n, instant) {
    n = Math.max(0, Math.min(this.slides.length - 1, n));
    if (n !== this.i) this.reset(true);
    this.i = n;
    [n, n - 1, n + 1].forEach(this.load, this);
    this.track.style.transition = instant ? 'none' : '';
    this.track.style.transform = 'translate3d(' + (-100 * n) + '%,0,0)';
    if (this.cur) this.cur.textContent = n + 1;
    this.dots.forEach(function (d, k) { d.classList.toggle('is-on', k === n); });
    var prev = this.d.querySelector('[data-pz-prev]'), next = this.d.querySelector('[data-pz-next]');
    if (prev) prev.disabled = n === 0;
    if (next) next.disabled = n === this.slides.length - 1;
  };

  /* keep the zoomed photo covering its own box: no panning into empty space */
  Viewer.prototype.clamp = function () {
    var im = this.img(); if (!im) return;
    var w = im.offsetWidth, h = im.offsetHeight;
    var mx = Math.max(0, (w * this.s - w) / 2), my = Math.max(0, (h * this.s - h) / 2);
    this.x = Math.max(-mx, Math.min(mx, this.x));
    this.y = Math.max(-my, Math.min(my, this.y));
  };

  Viewer.prototype.apply = function (animate) {
    var im = this.img(); if (!im) return;
    this.clamp();
    im.style.transition = animate ? 'transform .28s cubic-bezier(.2,.7,.2,1)' : 'none';
    im.style.transform = 'translate3d(' + this.x + 'px,' + this.y + 'px,0) scale(' + this.s + ')';
    this.d.classList.toggle('is-zoomed', this.s > 1.01);
  };

  Viewer.prototype.reset = function (animate) { this.s = 1; this.x = 0; this.y = 0; this.apply(animate); };

  /* point (client coords) relative to the photo's centre */
  Viewer.prototype.rel = function (cx, cy) {
    var im = this.img(), r = im.parentNode.getBoundingClientRect();
    return { x: cx - (r.left + r.width / 2), y: cy - (r.top + r.height / 2) };
  };

  /* zoom to scale s, keeping the photo point under (cx, cy) where it is */
  Viewer.prototype.zoomAt = function (s, cx, cy, animate) {
    s = Math.max(1, Math.min(MAX, s));
    var p = this.rel(cx, cy), k = s / this.s;
    this.x = p.x - (p.x - this.x) * k;
    this.y = p.y - (p.y - this.y) * k;
    this.s = s;
    if (s <= 1.01) { this.x = 0; this.y = 0; this.s = 1; }
    this.apply(animate);
  };

  Viewer.prototype.bind = function () {
    var self = this, st = this.stage;
    this.d.querySelector('[data-pz-close]').addEventListener('click', function () { self.close(); });
    var prev = this.d.querySelector('[data-pz-prev]'), next = this.d.querySelector('[data-pz-next]');
    if (prev) prev.addEventListener('click', function () { self.go(self.i - 1); });
    if (next) next.addEventListener('click', function () { self.go(self.i + 1); });
    this.d.addEventListener('cancel', function (e) { e.preventDefault(); self.close(); });
    this.d.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') self.go(self.i + 1);
      else if (e.key === 'ArrowLeft') self.go(self.i - 1);
    });
    /* clicking the dark area around the photo closes (desktop) */
    this.d.addEventListener('click', function (e) { if (e.target === self.d) self.close(); });

    var lastTap = 0, lastTapX = 0, lastTapY = 0, moved = false, startX = 0, startY = 0, t0 = 0;
    var pinch = null, pan = null, swipe = false;

    st.addEventListener('pointerdown', function (e) {
      if (e.target.closest('button')) return;
      try { st.setPointerCapture(e.pointerId); } catch (err) { /* finger already lifted */ }
      self.pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var ids = Object.keys(self.pts);
      moved = false; startX = e.clientX; startY = e.clientY; t0 = Date.now();
      if (ids.length === 2) {
        var a = self.pts[ids[0]], b = self.pts[ids[1]];
        pinch = { d: Math.hypot(a.x - b.x, a.y - b.y), s: self.s, mx: (a.x + b.x) / 2, my: (a.y + b.y) / 2, x: self.x, y: self.y };
        pan = null; swipe = false; self.track.style.transition = 'none';
      } else if (ids.length === 1) {
        if (self.s > 1.01) pan = { x: self.x, y: self.y, cx: e.clientX, cy: e.clientY };
        else { swipe = true; self.dragX = 0; self.track.style.transition = 'none'; }
      }
    });

    st.addEventListener('pointermove', function (e) {
      if (!self.pts[e.pointerId]) {
        /* desktop, zoomed: the photo follows the mouse */
        if (self.fine && e.pointerType === 'mouse' && self.s > 1.01) {
          var im = self.img(), r = im.parentNode.getBoundingClientRect();
          var fx = (e.clientX - r.left) / r.width - 0.5, fy = (e.clientY - r.top) / r.height - 0.5;
          var w = im.offsetWidth, h = im.offsetHeight;
          self.x = -fx * (w * self.s - w) * 1.1; self.y = -fy * (h * self.s - h) * 1.1;
          self.apply(false);
        }
        return;
      }
      self.pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (Math.abs(e.clientX - startX) + Math.abs(e.clientY - startY) > 8) moved = true;
      var ids = Object.keys(self.pts);
      if (pinch && ids.length >= 2) {
        var a = self.pts[ids[0]], b = self.pts[ids[1]];
        var d = Math.hypot(a.x - b.x, a.y - b.y), mx = (a.x + b.x) / 2, my = (a.y + b.y) / 2;
        var s = Math.max(1, Math.min(MAX, pinch.s * d / pinch.d));
        var p0 = self.rel(pinch.mx, pinch.my), k = s / pinch.s;
        self.s = s;
        self.x = p0.x - (p0.x - pinch.x) * k + (mx - pinch.mx);
        self.y = p0.y - (p0.y - pinch.y) * k + (my - pinch.my);
        self.apply(false);
      } else if (pan) {
        self.x = pan.x + (e.clientX - pan.cx); self.y = pan.y + (e.clientY - pan.cy);
        self.apply(false);
      } else if (swipe) {
        self.dragX = e.clientX - startX;
        var edge = (self.i === 0 && self.dragX > 0) || (self.i === self.slides.length - 1 && self.dragX < 0);
        var dx = edge ? self.dragX / 3 : self.dragX;
        self.track.style.transform = 'translate3d(calc(' + (-100 * self.i) + '% + ' + dx + 'px),0,0)';
      }
    });

    function end(e) {
      if (!self.pts[e.pointerId]) return;
      delete self.pts[e.pointerId];
      var left = Object.keys(self.pts).length;
      if (pinch) {
        if (left < 2) { pinch = null; if (self.s < 1.05) self.reset(true); }
        if (left === 1 && self.s > 1.01) { var id = Object.keys(self.pts)[0]; pan = { x: self.x, y: self.y, cx: self.pts[id].x, cy: self.pts[id].y }; }
        return;
      }
      if (swipe) {
        swipe = false; self.track.style.transition = '';
        var fast = Math.abs(self.dragX) > 40 && Date.now() - t0 < 300;
        if (self.dragX < -self.stage.offsetWidth * 0.18 || (fast && self.dragX < 0)) self.go(self.i + 1);
        else if (self.dragX > self.stage.offsetWidth * 0.18 || (fast && self.dragX > 0)) self.go(self.i - 1);
        else self.go(self.i);
      }
      pan = null;
      if (moved || e.type === 'pointercancel') return;
      /* tap / click */
      var now = Date.now();
      if (e.pointerType === 'mouse') {
        if (self.s > 1.01) self.reset(true); else self.zoomAt(TAP_ZOOM, e.clientX, e.clientY, true);
        return;
      }
      if (now - lastTap < 320 && Math.hypot(e.clientX - lastTapX, e.clientY - lastTapY) < 30) {
        if (self.s > 1.01) self.reset(true); else self.zoomAt(TAP_ZOOM, e.clientX, e.clientY, true);
        lastTap = 0;
      } else { lastTap = now; lastTapX = e.clientX; lastTapY = e.clientY; }
    }
    st.addEventListener('pointerup', end);
    st.addEventListener('pointercancel', end);

    /* trackpad pinch on Mac (ctrl + wheel), plain wheel pans when zoomed */
    st.addEventListener('wheel', function (e) {
      e.preventDefault();
      if (e.ctrlKey) self.zoomAt(self.s * Math.exp(-e.deltaY * 0.01), e.clientX, e.clientY, false);
      else if (self.s > 1.01) { self.x -= e.deltaX; self.y -= e.deltaY; self.apply(false); }
      else if (Math.abs(e.deltaX) > 30 && Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        if (!self.wheelLock) { self.go(self.i + (e.deltaX > 0 ? 1 : -1)); self.wheelLock = true; setTimeout(function () { self.wheelLock = false; }, 450); }
      }
    }, { passive: false });
    /* Safari's own pinch gesture events: stop them zooming the page behind */
    ['gesturestart', 'gesturechange'].forEach(function (ev) { st.addEventListener(ev, function (e) { e.preventDefault(); }); });
    window.addEventListener('resize', function () { if (self.d.open) { self.go(self.i, true); self.apply(false); } });
  };

  function init(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('dialog[data-pz]'), function (d) {
      if (d.__pz) return;
      var v = d.__pz = new Viewer(d);
      var section = d.closest('[data-product-section]') || document;
      Array.prototype.forEach.call(section.querySelectorAll('[data-pz-open]'), function (btn) {
        btn.addEventListener('click', function (e) {
          /* a swipe through the gallery is not a tap */
          if (btn.__swiped) { btn.__swiped = false; return; }
          e.preventDefault();
          v.open(parseInt(btn.getAttribute('data-pz-open'), 10) || 0);
        });
        var sx = 0;
        btn.addEventListener('pointerdown', function (e) { sx = e.clientX; btn.__swiped = false; });
        btn.addEventListener('pointermove', function (e) { if (Math.abs(e.clientX - sx) > 10) btn.__swiped = true; });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
